// extracted by mini-css-extract-plugin
module.exports = {"root":"panel_page_layout_root__1rDfR","frame":"panel_page_layout_frame__jKmMY","logo":"panel_page_layout_logo__3zfF3","main":"panel_page_layout_main__2VDUX"};